export const siteInfo = {
  name: '吃瓜官网',
  slogan: '娱乐圈黑料爆料第一站',
  tagline: '每日更新 · 独家爆料 · 深度扒皮',
  intro: '吃瓜官网是国内领先的娱乐圈内幕爆料聚合平台，专注明星黑料、综艺内幕、影视八卦等娱乐圈深度内容。平台每日更新海量独家爆料与深度扒皮文章，覆盖恋情曝光、税务风波、选秀黑幕、带货翻车等热门话题，为吃瓜群众提供最新、最全、最劲爆的娱乐资讯。无论你是资深瓜友还是刚入圈的吃瓜新手，吃瓜官网都能满足你的好奇心与探索欲。',
  stats: [
    { label: '每日更新内容', value: '200+' },
    { label: '独家爆料专题', value: '5000+' },
    { label: '活跃瓜友社区', value: '300万+' },
  ],
};

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '最新快讯', href: '#updates' },
  { label: '爆料视频', href: '#media' },
  { label: '瓜友热评', href: '#comments' },
  { label: '平台特色', href: '#features' },
];

export const contactInfo = {
  title: '投稿爆料',
  subtitle: '你有猛料，我有平台',
  description: '欢迎娱乐圈知情人士、业内人士和热心瓜友提供独家线索与爆料内容。我们严格保护爆料人隐私，所有投稿均经过专业团队核实后发布。',
  email: 'tips@chigua-official.com',
  wechat: 'chigua_tips',
};

export const focusTopics = [
  {
    id: 1,
    title: '顶流男星深夜密会神秘女子，酒店同框照片流出',
    category: '恋情曝光',
    summary: '某当红一线男星被拍到深夜与一名神秘女子先后进入某五星级酒店，次日清晨才分别离开，引发全网热议。',
    time: '3小时前',
    hot: true,
  },
  {
    id: 2,
    title: '热门选秀节目投票造假内幕全揭露',
    category: '综艺黑幕',
    summary: '知情人爆料某大型选秀节目存在系统性投票造假，节目组内部邮件曝光，多名选手晋级结果遭人为操控。',
    time: '6小时前',
    hot: true,
  },
  {
    id: 3,
    title: '娱乐圈新一轮税务稽查风暴来袭',
    category: '税务风波',
    summary: '据可靠消息，税务部门已向多位一线艺人发出稽查通知，涉及金额或达数亿元，娱乐圈人人自危。',
    time: '昨天',
    hot: false,
  },
  {
    id: 4,
    title: '知名导演新片陷抄袭争议，原作方已发律师函',
    category: '影视风波',
    summary: '某票房大导最新作品被指抄袭海外独立电影，网友逐帧对比画面高度相似，原作方已正式启动法律程序。',
    time: '2天前',
    hot: true,
  },
  {
    id: 5,
    title: '某女星豪门婚姻触礁，社交平台已取关婆家全员',
    category: '婚姻变局',
    summary: '嫁入豪门的某知名女星近日被发现在社交平台取关了丈夫及其全部家人，婚变传闻甚嚣尘上。',
    time: '3天前',
    hot: false,
  },
];

export const topicIndex = [
  { id: 1, title: '明星恋情', icon: 'ri-heart-line', count: 128, color: 'bg-primary-500' },
  { id: 2, title: '综艺内幕', icon: 'ri-tv-line', count: 96, color: 'bg-accent-500' },
  { id: 3, title: '影视爆料', icon: 'ri-film-line', count: 84, color: 'bg-primary-500' },
  { id: 4, title: '音乐圈八卦', icon: 'ri-music-line', count: 72, color: 'bg-accent-500' },
  { id: 5, title: '网红翻车', icon: 'ri-alert-line', count: 115, color: 'bg-primary-500' },
  { id: 6, title: '时尚秘辛', icon: 'ri-t-shirt-line', count: 53, color: 'bg-accent-500' },
  { id: 7, title: '体育花边', icon: 'ri-basketball-line', count: 67, color: 'bg-primary-500' },
  { id: 8, title: '直播争议', icon: 'ri-live-line', count: 91, color: 'bg-accent-500' },
];

export const aboutInfo = {
  title: '关于吃瓜官网',
  content: '吃瓜官网创立于2020年，是国内最具影响力的娱乐八卦爆料聚合平台之一。我们秉持"真实爆料、理性吃瓜"的理念，汇聚全网最热门、最新鲜的明星黑料与娱乐圈内幕。平台拥有专业的编辑团队与严格的内容审核机制，确保每一条爆料都经过多方求证后才对外发布。三年来，吃瓜官网已累计发布超过5000篇独家爆料与深度扒皮内容，服务超过300万活跃瓜友，成为中文互联网吃瓜文化的标志性阵地。我们致力于为每一位吃瓜爱好者提供最优质、最及时、最全面的娱乐圈资讯体验。',
  highlights: [
    { label: '创立时间', value: '2020年' },
    { label: '独家内容', value: '5000+' },
    { label: '合作媒体', value: '200+' },
    { label: '日活用户', value: '100万+' },
  ],
};

export const updates = [
  {
    id: 1,
    title: '某知名男星被拍到在片场与经纪人发生激烈争执，疑似因片酬分配不均',
    time: '刚刚',
    tag: '最新',
    tagColor: 'bg-primary-500',
  },
  {
    id: 2,
    title: '某热门综艺录制现场突发意外，一名选手在挑战环节受伤送医',
    time: '2小时前',
    tag: '突发',
    tagColor: 'bg-accent-500',
  },
  {
    id: 3,
    title: '知名歌手新歌被指抄袭海外作品，网友逐段对比相似度高达80%',
    time: '5小时前',
    tag: '热议',
    tagColor: 'bg-primary-500',
  },
  {
    id: 4,
    title: '某女星深夜发文暗示分手，文中"各自安好"四字引发粉丝集体哀嚎',
    time: '昨天 23:45',
    tag: '恋情',
    tagColor: 'bg-accent-500',
  },
  {
    id: 5,
    title: '某男星直播带货翻车名场面引发全网群嘲，品牌方连夜发声明切割',
    time: '2天前',
    tag: '翻车',
    tagColor: 'bg-primary-500',
  },
  {
    id: 6,
    title: '某剧组被曝拖欠群演工资长达三个月，工会已介入调查处理',
    time: '3天前',
    tag: '维权',
    tagColor: 'bg-accent-500',
  },
  {
    id: 7,
    title: '某品牌突然宣布与代言人解约，知情人透露系艺人个人原因导致',
    time: '1周前',
    tag: '解约',
    tagColor: 'bg-primary-500',
  },
];

export const hotTopics = [
  { id: 1, name: '#顶流塌房', count: '128万', hot: true },
  { id: 2, name: '#综艺剧本', count: '96万', hot: true },
  { id: 3, name: '#明星整容', count: '85万', hot: true },
  { id: 4, name: '#带货翻车', count: '112万', hot: true },
  { id: 5, name: '#娱乐圈税务', count: '78万', hot: false },
  { id: 6, name: '#私生饭乱象', count: '64万', hot: false },
  { id: 7, name: '#选秀内定', count: '91万', hot: true },
  { id: 8, name: '#抄袭风波', count: '73万', hot: false },
  { id: 9, name: '#豪门婚姻', count: '88万', hot: false },
  { id: 10, name: '#网红造假', count: '105万', hot: true },
];

export const features = [
  {
    id: 1,
    icon: 'ri-refresh-line',
    title: '每日海量更新',
    description: '全网最新明星黑料与娱乐圈内幕每日刷新，200+条新鲜内容滚动更新，不错过任何一个劲爆大瓜。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '匿名投稿保护',
    description: '严格保护每一位爆料人的隐私安全，多层加密匿名投稿系统，让知情人放心爆料、安全吃瓜。',
  },
  {
    id: 3,
    icon: 'ri-search-eye-line',
    title: '深度调查扒皮',
    description: '专业内容团队多方求证、深入调查，每篇深度扒皮文章都经过交叉核实，确保爆料真实可信。',
  },
  {
    id: 4,
    icon: 'ri-flashlight-line',
    title: '实时热点追踪',
    description: '7×24小时全天候监控娱乐圈动态，热点事件发生后30分钟内推送第一手爆料，让你始终走在吃瓜前线。',
  },
];

export const appEntry = {
  title: '随时随地，掌上吃瓜',
  subtitle: '吃瓜官网移动端体验',
  description: '关注吃瓜官网官方公众号与小程序，随时随地获取最新明星黑料与娱乐圈内幕。无需下载APP，微信内即可畅享全部吃瓜内容，推送提醒让你不再错过任何重磅爆料。',
  features: ['实时推送爆料通知', '独家深度内容抢先看', '瓜友社区互动讨论', '离线缓存随时阅读'],
  qrCodeText: '扫码关注吃瓜官网',
};

export const comments = [
  {
    id: 1,
    avatar: '匿',
    name: '资深瓜农',
    time: '15分钟前',
    content: '这个瓜保熟吗？不过看证据链还挺完整的，我先吃为敬！兄弟们冲啊！',
    likes: 2389,
  },
  {
    id: 2,
    avatar: '名',
    name: '娱乐圈观察者',
    time: '1小时前',
    content: '终于有人站出来说真话了，这个行业确实需要更多透明度和监督。支持吃瓜官网！',
    likes: 1856,
  },
  {
    id: 3,
    avatar: '吃',
    name: '每天必刷吃瓜',
    time: '2小时前',
    content: '每天早上第一件事就是打开吃瓜官网看看有没有新料，信息量太大了，根本停不下来。',
    likes: 1523,
  },
  {
    id: 4,
    avatar: '热',
    name: '八卦小能手',
    time: '3小时前',
    content: '建议出个APP版本啊，手机浏览器看虽然也行但总感觉差点意思，出APP我第一个下载！',
    likes: 987,
  },
  {
    id: 5,
    avatar: '老',
    name: '三年老瓜友',
    time: '5小时前',
    content: '从2020年就开始在这吃瓜了，亲眼看着这个平台越来越专业，内容质量和深度都有质的飞跃。',
    likes: 2104,
  },
];

export const mediaCards = [
  {
    id: 1,
    title: '独家直击：某顶流后台情绪失控全程记录',
    duration: '03:24',
    views: '128万',
    category: '独家爆料',
  },
  {
    id: 2,
    title: '现场实拍：某综艺录制现场选手激烈冲突画面',
    duration: '05:18',
    views: '96万',
    category: '综艺内幕',
  },
  {
    id: 3,
    title: '深度深扒：某女星亿元豪宅内部细节全曝光',
    duration: '08:42',
    views: '85万',
    category: '明星生活',
  },
  {
    id: 4,
    title: '年度盘点：娱乐圈十大翻车名场面合集回顾',
    duration: '12:06',
    views: '256万',
    category: '年度精选',
  },
];

export const ranking = [
  {
    rank: 1,
    title: '顶流男星深夜密会绯闻持续发酵，女方身份被扒',
    heat: '999万',
    change: 'up',
  },
  {
    rank: 2,
    title: '知名综艺节目黑幕大起底，多位参赛者联合发声',
    heat: '856万',
    change: 'up',
  },
  {
    rank: 3,
    title: '某国际品牌代言纠纷升级，双方律师团队介入',
    heat: '723万',
    change: 'new',
  },
  {
    rank: 4,
    title: '选秀节目投票系统被曝存在严重漏洞与人为干预',
    heat: '598万',
    change: 'down',
  },
  {
    rank: 5,
    title: '当红网红直播口误自曝行业内幕，品牌集体沉默',
    heat: '467万',
    change: 'up',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '吃瓜官网是什么平台？',
    answer: '吃瓜官网是国内领先的娱乐圈内幕爆料聚合平台，专注明星黑料、综艺八卦、影视内幕等娱乐资讯的汇集与深度分析。我们聚合全网最热门的娱乐爆料，为吃瓜群众提供一站式娱乐圈信息消费体验。',
  },
  {
    id: 2,
    question: '如何向吃瓜官网投稿爆料？',
    answer: '你可以通过页面上方的"投稿爆料"区域联系我们，或直接发送邮件至官方投稿邮箱。我们严格保护每一位爆料人的隐私信息，所有投稿都会经过专业编辑团队审核后发布。',
  },
  {
    id: 3,
    question: '平台上的内容是否真实可靠？',
    answer: '吃瓜官网秉持"真实爆料、理性吃瓜"的理念。所有内容在发布前均经过专业编辑团队多方求证和交叉核实。我们标注了每篇内容的来源与可信度评级，帮助瓜友辨别信息真伪。',
  },
  {
    id: 4,
    question: '如何第一时间获取最新爆料？',
    answer: '你可以关注吃瓜官网官方公众号并开启推送通知，或定期访问网站首页的"最新快讯"版块。我们采用7×24小时全天候内容监控机制，确保热点事件发生后第一时间推送。',
  },
  {
    id: 5,
    question: '吃瓜官网是否收费？',
    answer: '吃瓜官网目前为完全免费的信息聚合平台，所有公开内容均可免费浏览。我们通过广告与品牌合作维持平台运营，未来也不会对基础内容阅读收取任何费用。',
  },
];

export const infoCards = [
  {
    id: 1,
    title: '深度调查：娱乐圈资本的局中局',
    category: '深度扒皮',
    summary: '揭开娱乐圈背后错综复杂的资本关系网，还原明星、经纪公司、投资方三方博弈的真实面貌。',
    time: '1天前',
    reads: '56万',
  },
  {
    id: 2,
    title: '揭秘：明星天价片酬背后的利益分配链条',
    category: '行业揭秘',
    summary: '一线艺人片酬动辄上亿，这背后涉及到平台、制作方、经纪公司的复杂利益分配机制。',
    time: '2天前',
    reads: '43万',
  },
  {
    id: 3,
    title: '独家记录：某综艺录制内幕全程大公开',
    category: '独家爆料',
    summary: '从海选到决赛，内部人士全程记录某热门综艺不为人知的幕后故事与选拔真相。',
    time: '3天前',
    reads: '68万',
  },
  {
    id: 4,
    title: '分析：为什么顶流明星频频翻车？',
    category: '行业分析',
    summary: '从人设崩塌到法律红线，深度分析近年来多位顶流明星翻车背后的共同原因与警示。',
    time: '4天前',
    reads: '39万',
  },
  {
    id: 5,
    title: '专题：2024年度娱乐圈十大重磅事件回顾',
    category: '年度专题',
    summary: '从年初的税务风波到年末的恋情曝光，回顾过去一年娱乐圈最令人震惊的十大事件。',
    time: '5天前',
    reads: '91万',
  },
];